import WishstoneApp from "./WishstoneApp";
function App() { return <WishstoneApp />; }
export default App;
